var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home"},[_c('Header'),_c('VideoFram'),_c('kurse-home'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }